import React from 'react';
import { Container } from 'reactstrap';
import { WhitePanelLayout } from '@dom/components';
import { withRouter } from 'react-router-dom';
import { Head } from '@dom/components';
import config from '@dom/config';

function GuidePaymentFailure({ history }) {
  const goBack = () => history.goBack();
  return <Head title="Payment Failed">
    <Container>
      <WhitePanelLayout>
        <div>
          <h2>Payment Failed!</h2>
          <p>
            <icon className=""/> Something went wrong while processing your payment. Please go back and try again. <span onClick={goBack} style={{ color: '#3A5DB7' }} >Go Back</span>
          </p>
          <p>
            Also, if you need some help please email us at{' '}
            <a target="_blank" href={`mailto:${config.honeyguideEmail}`} rel="noopener noreferrer nofollow">{config.honeyguideEmail}</a> 
            or call / whatsapp us at 
            <a style={{ color: '#3A5DB7' }} target="_blank" href={`https://wa.me/${config.honeyguidePhoneNumber}`} rel="noopener noreferrer nofollow">{config.honeyguidePhoneNumber}</a>.
          </p>
        </div>
      </WhitePanelLayout>
    </Container>
  </Head>
};

export default withRouter(GuidePaymentFailure);
